export default "__VITE_ASSET__CZYIF7d6__"